<template>
    <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center">

            <li class="page-item">
                <button class="page-link" aria-label="Previous" @click="goToNext()" :disabled="!pagination.hasPrev">
                    {{Lang.get('pagination.prev_page')}}
                </button>
            </li>

            <li class="page-item">
                <button class="page-link" aria-label="Next" @click="goToPrev()" :disabled="!pagination.hasNext">
                    {{Lang.get('pagination.next_page')}}
                </button>
            </li>

        </ul>

<!--        <div class="text-center mt-2">-->
<!--            <small>-->
<!--                Total <strong>{{pagination.total}}</strong> records,-->
<!--                showing from <strong>{{pagination.from}}</strong>-->
<!--                to <strong>{{pagination.to}}</strong>-->
<!--            </small>-->
<!--        </div>-->

    </nav>
</template>

<script>
    export default {
        props: {
            pagination: {
                type: [Object, Array],
                required: true
            },

            offset: {
                type: Number,
                default: 5
            }
        },

        data() {
            return {
                //
            }
        },

        methods: {
            goToPrev() {
              this.$emit('paginate', this.pagination.nextPage);
            },

            goToNext() {
              this.$emit('paginate', this.pagination.previousPage);
            },
        },

        computed: {
            //
        }
    }
</script>

<style scoped>
    nav {
        background-color: transparent !important;
        box-shadow: none !important;
        color: #000 !important;
    }

    button:disabled {
        cursor: not-allowed;
    }
</style>